import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import { ITextLinkComponentProps } from './types';

import styles from './TextLinkComponent.module.scss';

export const TextLinkComponent: React.FC<ITextLinkComponentProps> = ({
  children,
  className,
  onClick,
  ...restProps
}) => {
  return (
    <Box
      {...restProps}
      className={clsx(styles.link, { [styles.clickableLink]: !!onClick }, className)}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
